// Generated by purs version 0.14.3
"use strict";
var $foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/refs/v5.0.0/src/Effect/Ref.js");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Effect = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/effect/v3.0.0/src/Effect.purs");
var modify$prime = $foreign.modifyImpl;
var modify = function (f) {
    return modify$prime(function (s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var modify_ = function (f) {
    return function (s) {
        return Data_Functor["void"](Effect.functorEffect)(modify(f)(s));
    };
};
module.exports = {
    "modify'": modify$prime,
    modify: modify,
    modify_: modify_,
    "new": $foreign["new"],
    newWithSelf: $foreign.newWithSelf,
    read: $foreign.read,
    write: $foreign.write
};

